export default {
  steps: {
    discount: 'Desconto',
    mobile_app: 'Aplicação móvel',
    business_info: 'Informações da empresa',
    create_preview: 'Criar contrato de pré-visualização',
    preview: 'Pré-visualizar contrato',
    sign: 'Assinar contrato',
  },
  buttons: {
    back: 'Voltar',
    continue: 'Continuar',
  },
  agreement:
    'A mudança para anual aplica o desconto de {{discount}}% ao seu plano {{plan}}. A sua faturação continua mensalmente a {{amount}} por mês com um compromisso de {{months}} meses.',
  toasts: {
    failed_to_save_changes: 'Falha ao guardar as alterações',
    failed_to_switch: 'Falha ao mudar para anual',
    switched_to_annual: 'Contrato alterado para anual 👌',
  },
};
